if (!Element.prototype.isInViewport) {

    /***
     * Checks if the element is inside the viewport
     * @param heightOffset - number (Optional). The amount allowed above and below the viewport while still being visible (px)
     * @param widthOffset - number (Optional). The amount allowed left and right the viewport while still being visible (px)
     * @param strict - boolean (Optional). If strict, it will just return true if the whole element is inside the viewport, not just part of it.
     * @returns {boolean} if any part of the element is in the viewport or within the offset
     */
    Element.prototype.isInViewport = function (heightOffset, widthOffset, strict) {
        var rect = this.getBoundingClientRect();
        var html = document.documentElement;
        var heightToAdd = isNaN(heightOffset) ? 0 : heightOffset;
        var widthToAdd = isNaN(widthOffset) ? 0 : widthOffset;

        if (!strict) {
            return rect.bottom > 0 - heightToAdd &&
                rect.top < (window.innerHeight || html.clientHeight) + heightToAdd &&
                rect.right > 0 - widthToAdd &&
                rect.left < (html.clientWidth || window.innerWidth) + widthToAdd;
        }

        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || html.clientHeight) &&
            rect.right <= (html.clientWidth || window.innerWidth)
        );
    }
}